export default function SkillsLearned() {
  const skills = [
    { icon: 'ri-focus-2-line', title: 'Подготовка к звонку', desc: 'Как собрать информацию и сформулировать цель до звонка' },
    { icon: 'ri-door-open-line', title: 'Открытие разговора', desc: 'Первые 15 секунд, которые определяют исход диалога' },
    { icon: 'ri-eye-line', title: 'Удержание внимания', desc: 'Как удержать клиента, когда он готов положить трубку' },
    { icon: 'ri-question-answer-line', title: 'Выявление потребностей', desc: 'Система вопросов, раскрывающих истинные задачи клиента' },
    { icon: 'ri-headphone-line', title: 'Активное слушание', desc: 'Слышать не слова, а смысл: техники перефразирования и резюмирования' },
    { icon: 'ri-search-eye-line', title: 'SPIN-вопросы', desc: 'Ситуационные, проблемные, извлекающие и направляющие вопросы' },
    { icon: 'ri-heart-pulse-line', title: 'Работа с эмоциями', desc: 'Эмпатия и метасообщения: как тон и темп влияют на решение' },
    { icon: 'ri-guide-line', title: 'Управление разговором', desc: 'Как вести беседу к цели, не позволяя клиенту уйти в сторону' },
    { icon: 'ri-shield-user-line', title: 'Работа с секретарём', desc: 'От барьера к союзнику: стратегия прохождения секретаря' },
    { icon: 'ri-key-2-line', title: 'Выход на ЛПР', desc: 'Как дойти до человека, который принимает решение о покупке' },
    { icon: 'ri-chat-check-line', title: 'Возражения', desc: 'Присоединение, а не защита: техника работы с любыми возражениями' },
    { icon: 'ri-check-double-line', title: 'Закрытие звонка', desc: 'Как завершить разговор конкретным следующим шагом' },
    { icon: 'ri-calendar-check-line', title: 'Назначение следующего шага', desc: 'Договорённость, а не обещание: чёткий план после звонка' },
    { icon: 'ri-loop-left-line', title: 'Повторный контакт', desc: 'Как построить систему возврата и не потерять клиента после паузы' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему учатся сотрудники
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждый навык отрабатывается на реальных кейсах компании. Никакой абстрактной теории — только то, что участники применят в следующем же звонке.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {skills.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-gray-100 transition-colors group">
              <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mb-4">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}